import { ROLES, ROUTES } from '../routes/constants';

// TODO: use enum for role
export const getHomeRoute = (role: string): string =>
  role === ROLES.systemAdmin ? ROUTES.manageClients : ROUTES.manageSpheres;
